export const isObject = (obj: any): boolean => obj === Object(obj);
